Gift = require '../../../gift_button/frontend/gift'

window.MultiOptionModal ?= {}

MultiOptionModal.init = (payload) ->
  return unless payload?.buyButton.multiOptionEnabled

  openMultiOptionModal = (e) ->
    $modal = $ '#options'
    return unless $modal.length
    return if $modal.hasClass 'show-modal'
    return if  $(".header-row-sticky").is(":visible") and not payload.buyButton.multiOptionInline

    unless BuyButton.view.$multiOptions.filter('.selected').length
      firstAvailableOption = BuyButton.view.$multiOptions.not(":disabled")[0]
      BuyButton.view.updateMultiOptionBreakoutButton currentTarget: firstAvailableOption

    GIG.Modal.open(el: $modal)

    {stopTheBus: true}

  if payload.buyButton.multiOptionInline
    BuyButton.eventBus.board('view_options_clicked', openMultiOptionModal)
  else
    BuyButton.eventBus.board('buy_button_clicked', openMultiOptionModal)(998)

  $triggers = $(".show-multi-option-modal")
  $triggers.click openMultiOptionModal
  GIG.Modal.onClose Gift.removeCookie, 'options'

module.exports = MultiOptionModal
